import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';
export default class UploadButton extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isMediaUploadButton", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs.uploader.on('uploaded', () => {
      const form = this.$('form')[0];
      if (form) {
        form.reset();
      }
      m.redraw();
    });
    this.isMediaUploadButton = vnode.attrs.isMediaUploadButton ?? false;
  }
  view() {
    const buttonText = this.attrs.uploader.uploading ? app.translator.trans('fof-upload.forum.states.loading') : app.translator.trans('fof-upload.forum.buttons.upload');
    return m(TextEditorButton, {
      className: classList(['Button', 'hasIcon', 'fof-upload-button', !this.isMediaUploadButton && !this.attrs.uploader.uploading && 'Button--icon', !this.isMediaUploadButton && !this.attrs.uploader.uploading && 'Button--link', this.attrs.uploader.uploading && 'uploading']),
      icon: !this.attrs.uploader.uploading && 'fas fa-file-upload',
      onclick: this.uploadButtonClicked.bind(this),
      disabled: this.attrs.disabled,
      title: buttonText
    }, this.attrs.uploader.uploading && m(LoadingIndicator, {
      size: "small",
      display: "inline",
      className: "Button-icon"
    }), (this.isMediaUploadButton || this.attrs.uploader.uploading) && m("span", {
      className: "Button-label"
    }, buttonText), m("form", null, m("input", {
      type: "file",
      multiple: true,
      onchange: this.process.bind(this)
    })));
  }
  process(_e) {
    const files = this.$('input').prop('files');
    if (!files || files.length === 0) {
      return;
    }
    this.attrs.uploader.upload(files, !this.isMediaUploadButton);
  }
  uploadButtonClicked(_e) {
    this.$('input').click();
  }
}
flarum.reg.add('fof-upload', 'forum/components/UploadButton', UploadButton);